import {EventDetailsButtonStyle} from '@wix/wix-events-commons-statics'
import c from '../components/classnames.scss'
import {isHollowButton} from './settings'

export const getFormClassName = (buttonStyle: EventDetailsButtonStyle) =>
  isHollowButton(buttonStyle) ? c.formWithHollowButton : c.formWithFullButton
